<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>钻头管理</el-breadcrumb-item>
      <el-breadcrumb-item>钻头列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="项目">
            <ProjectSelect v-model="filter.project_id"></ProjectSelect>
          </el-form-item>
          <el-form-item label="型号">
            <el-input
              size="small"
              v-model="filter.model_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="序列号">
            <el-input
              size="small"
              v-model="filter.serial_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="零件号">
            <el-input
              size="small"
              v-model="filter.component_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>

    <div class="panel">
      <!-- <el-button
        type="primary"
        size="small"
        v-code="22101"
        @click="$router.push('/report/drills/new')"
      >
        添加钻头
      </el-button> -->
      <!-- <file-button
        style="display: inline-block"
        class="ml-10"
        :plain="false"
        v-code="22102"
        :exportButton="false"
        obj="drill"
        name="导入复合片"
        @importCallback="getData(true)"
      ></file-button> -->
      <mytable :list="list"></mytable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { drillList } from '../../../service/getData'
import ProjectSelect from '../../../components/select/project_select.vue'
import mytable from './_table'

export default {
  components: {
    mytable,
    ProjectSelect,
  },
  data() {
    return {
      filter: {
        page: 1,
        size: 10,
        model_number: '',
        serial_number: '',
        component_number: '',
        project_id: '',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.model_number = ''
        this.filter.serial_number = ''
        this.filter.component_number = ''
        this.filter.project_id = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1
      let res = await drillList(params)
      this.list = res.data.list
      this.total = res.data.count
    },
  },
}
</script>